<template>
    <div class="aboutUs">
        <img class="logo" src="../../../assets/images/logo.png" alt="">
        <p class="projectName">{{config.name}}</p>
        <p class="version">版本号：{{config.version}}</p>
        <CellGroup>
            <Cell :title="'官方网站: ' + projectConfig.officialUrl" style="background-color: #f9f9fb">
                <img slot="icon" class="icon" src="../../../assets/images/ic_aboutUs_company.png" alt="">
            </Cell>
            <Cell :title="'客服电话：' + projectConfig.customerServicePhone" style="background-color: #f9f9fb">
                <img slot="icon" class="icon" src="../../../assets/images/ic_aboutUs_phone.png" alt="">
            </Cell>
            <Cell :title="'公众号：' + projectConfig.officialAccount" style="background-color: #f9f9fb">
                <img slot="icon" class="icon" src="../../../assets/images/ic_aboutUs_message.png" alt="">
            </Cell>
        </CellGroup>
        <p class="time">人工服务时间：{{projectConfig.beginTime}}-{{projectConfig.endTime}}</p>
    </div>
</template>

<script>
    /*
    * 关于我们
    * */
    import {Cell, CellGroup} from 'vant';
    import config from '../../../Config'
    import {mapState} from 'vuex'

    export default {
        name: "AboutUs",
        components: {
            Cell, CellGroup
        },
        computed: {
            ...mapState(['projectConfig'])
        },
        data() {
            return {
                config,
            }
        },
    }
</script>

<style lang='less' scoped>
    .aboutUs {
        position: relative;
        min-height: 100vh;
        padding-top: 6.7vw;
        background-color: #f9f9fb;
        box-sizing: border-box;

        .logo {
            display: block;
            width: 18.9vw;
            height: 18.9vw;
            margin: 0 auto;
        }

        .projectName {
            margin: 2vw 0 3.1vw;
            font-size: 4.8vw;
            color: #333333;
            text-align: center;
        }

        .version {
            margin-bottom: 5vw;
            font-size: 3.2vw;
            text-align: center;
            color: #898989;
        }

        .icon {
            width: 5.7vw;
            height: 5.7vw;
            margin-right: 4vw;
        }

        .time {
            position: absolute;
            bottom: 8.5vw;
            width: 100%;
            text-align: center;
            font-size: 3.2vw;
            color: #b2b2b2;
        }
    }
</style>



// WEBPACK FOOTER //
// src/page/mine/aboutUs/AboutUs.vue